import { useTheme } from "@mui/material";
import { ControllerRenderProps } from "react-hook-form";

import { DonationPaymentInput } from "../../../../contexts/FormV2Context";

import { useTranslate } from "@/common/hooks/useTranslate";
import { TicketingPaymentInput } from "@/common/types/ticketing";
import { FormRadioSelectGroup } from "@/forms-design-system/FormRadioSelectGroup";
import { InvalidThemeErrorMessage } from "@/forms-design-system/InvalidThemeErrorMessage";

interface GiftAidRadioProps {
  field?: ControllerRenderProps<DonationPaymentInput | TicketingPaymentInput, "addGiftAid">;
  errorMessage?: string;
  onChange?: (value: boolean) => void;
  questionId?: string;
}

export const GiftAidRadio = ({ field, errorMessage, onChange, questionId }: GiftAidRadioProps) => {
  const theme = useTheme();
  const { t } = useTranslate();

  if (!theme.palette.forms || !theme.palette.formsComponents?.giftAidBlock) {
    return <InvalidThemeErrorMessage />;
  }

  const options = [
    { label: t("donationForm", "giftAidBlock.radio.yes"), value: true },
    { label: t("donationForm", "giftAidBlock.radio.no"), value: false },
  ];

  return (
    <FormRadioSelectGroup
      {...field}
      options={options}
      aria-labelledby={questionId}
      errorMessage={errorMessage}
      size="small"
      layout="horizontal"
      onChange={(event) => {
        field?.onChange(event);
        onChange?.(event as boolean);
      }}
    />
  );
};
